import styled from "@yb/styled-px2rem";

const Text = styled.span`
	position: relative;
	font-size: 0;
	&::before {
		display: inline-block;
		margin-left: 3px;
		font-size: 15px;
		color: var(--red-color);
		content: "*";
	}
`;

const RequiredCheck = () => <Text>필수입력</Text>;

export default RequiredCheck;
